/* istanbul ignore file */
import { useState, useEffect } from 'react'
import useDebounce from './useDebounce'
import browserHistory from '../browserHistory'

function useOnBrowserBack (onBack, milliSeconds = 100, browserHistoryFn = browserHistory) {
  const [backing, setBacking] = useState(false)
  const debounceBacking = useDebounce(backing, milliSeconds)

  useEffect(() => {
      // eslint-disable-next-line no-undef
      addEventListener('popstate', () => {
        browserHistoryFn && browserHistoryFn.forward()
          setBacking(true)
      })
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setBacking])

  useEffect(() => {
    if (backing && debounceBacking) {
      onBack()
      setBacking(false)
    }
  }, [ debounceBacking, onBack, backing ])

  return debounceBacking
}

export default useOnBrowserBack
